import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobals from '../globals';
import { Configuration } from '../app.configuration';

@Injectable()
export class DispatcherService {
  private _languages = myGlobals.apiurl + 'utility/languages';
  private _zoneUrl = myGlobals.apiurl + 'customer/drivers/';
  private _addinfoUrl = myGlobals.apiurl + 'customer/bookingHistory';
  private _images = myGlobals.apiurl + 'utility/uploadImage';
  private _logout = myGlobals.apiurl + 'customer/signOut';
  private _appconfig = myGlobals.apiurl + 'customer/appConfig/3';
  private _profile = '';
  private _getdrivers = '';
  private _goodstypes = '';
  private _pending_reff = '';
  private _submitreasons = '';
  private _getdetUrl = '';
  private _surgePrice = myGlobals.apiurl + 'customer/fareEstimate';
  private _priceAll = myGlobals.apiurl + 'customer/fareEstimateAll';
  private _goodsTypes = myGlobals.apiurl + 'customer/goodsType/';
  private _postBooking = myGlobals.apiurl + 'customer/book';
  private _cusProfile = myGlobals.apiurl + 'customer/profile';
  // wallet services for customer
  private _getcards = myGlobals.apiurl + 'customer/card';
  private _addcards = myGlobals.apiurl + 'customer/card';
  private _deletecards = myGlobals.apiurl + 'customer/card';
  private _wallet_details = myGlobals.apiurl + 'customer/walletDetail';
  private _wallet_transactions =
    myGlobals.apiurl + 'customer/walletTransaction';
  private _paymentSettings = myGlobals.apiurl + 'customer/paymentSetting';
  private _rechargeWallet = myGlobals.apiurl + 'customer/rechargeWallet';
  private _getFavoriteDriver = myGlobals.apiurl + 'customer/vehicletypeFavouriteDriver?vehicleId=';
  constructor(private _http: HttpClient, private _conf: Configuration) { }

  // ZONE VALIDATION FOR ADD NEW FORM
  zone(data: any) {
    return this._http.get(
      this._zoneUrl +
      data.latitude +
      '/' +
      data.longitude +
      '/' +
      data.mqttTopic +
      '/' +
      1 +
      '/' +
      1,
      { headers: this._conf.header }
    );
  }

  // ZONE VALIDATION FOR ADD NEW FORM
  fareEstimate(data: any) {
    return this._http.post(this._surgePrice, data, {
      headers: this._conf.header
    });
  }

  // Get All Vehicles price data
  fareEstimateAll(data: any) {
    return this._http.post(this._priceAll, data, {
      headers: this._conf.header
    });
  }
  // ZONE VALIDATION FOR ADD NEW FORM
  getGoodstypes(data: any) {
    return this._http.get(this._goodsTypes + data.vehicleTypeId, {
      headers: this._conf.header
    });
  }

  // ZONE VALIDATION FOR ADD NEW FORM
  getFavoriteDriversBasedOnVehicle(data: any) {
    return this._http.get(`${this._getFavoriteDriver}${data.vehicleTypeId}`, {
      headers: this._conf.header
    });
  }
  // Post BOOKING
  postBooking(data: any) {
    const headers = new HttpHeaders();
    return this._http.post(this._postBooking, data, {
      headers: this._conf.header
    });
  }
  // get customer profile
  getProfile() {
    return this._http.get(this._cusProfile, { headers: this._conf.header });
  }

  uploadImages(fileToUpload) {
    const formData = new FormData();
    formData.append('image', fileToUpload);
    return this._http.post(this._images, formData);
  }

  // ADD NEW BOOKING API----------------------------------------------------

  addinfo(user: any) {
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    headers.append('Content-Type', 'application/json');
    return this._http.post(this._addinfoUrl, user, { headers: headers });
  }

  // GET USER DATA API----------------------------------------------------
  getdet(user: any) {
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    headers.append('Content-Type', 'application/json');
    return this._http.post(this._getdetUrl, user, { headers: headers });
  }

  // LOGOUT SERVICE

  loggedout(user: any) {
    return this._http.post(this._logout, user, { headers: this._conf.header });
  }
  // GET PROFILE

  profile(user: any) {
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.get(this._profile, { headers: headers });
  }

  // GET PENDING REFERRALS

  pendingRef(user: any) {
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.get(this._pending_reff, { headers: headers });
  }
  // update PROFILE

  updateprofile(user: any) {
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.put(this._profile, user, { headers: headers });
  }

  // GETTING ALL ZONES FOR PREPARING BULK UPLOAD IT CONVERTS TO TXT FORMAT AND DOWNLOAD
  appconfig(user: any) {
    return this._http.get(this._appconfig, { headers: this._conf.header });
  }

  // GETTING ALL THE DRIVERS LIST
  getdrivers(user: any) {
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.get(
      this._getdrivers +
      '/' +
      user.lt +
      '/' +
      user.lg +
      '/' +
      sessionStorage.getItem('chn') +
      '/' +
      sessionStorage.getItem('presence'),
      { headers: headers }
    );
  }

  // GET ALL THE SLAVE TYPES
  goodstypes(user: any) {
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.get(this._goodstypes, { headers: headers });
  }

  // GET review reasons based on rating
  submitereivew(user: any) {
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.post(this._submitreasons, user, { headers: headers });
  }

  // customer services for wallet

  // GETTING ALL THE CARDS ADDED
  getcards(user: any) {
    return this._http.get(this._getcards, { headers: this._conf.header });
  }

  // add cards
  addcards(user: any) {
    return this._http.post(this._addcards, user, {
      headers: this._conf.header
    });
  }

  // delete cards
  deletecard(user: any) {
    const body = {
      headers: this._conf.header,
      body: user
    };
    return this._http.delete(this._deletecards, body);
  }

  // get wallet details
  wallet(user: any) {
    return this._http.get(this._wallet_details, { headers: this._conf.header });
  }

  // recharge wallet from wallet component
  recharge(user: any) {
    return this._http.post(this._rechargeWallet, user, {
      headers: this._conf.header
    });
  }

  // GET wallet transactions for wallet page
  wallettrans(user: any) {
    return this._http.get(this._wallet_transactions + '/' + user.pageIndex, {
      headers: this._conf.header
    });
  }

  // GET PROFILE\
  payment(user: any) {
    return this._http.get(this._paymentSettings, {
      headers: this._conf.header
    });
  }

  getLanguages() {
    return this._http.get(this._languages);
  }
}
